module.exports = __webpack_public_path__ + "static/media/mail-outline.1e585994.svg";